import { render, staticRenderFns } from "./changeLog.vue?vue&type=template&id=5b216c62&scoped=true&"
import script from "./changeLog.vue?vue&type=script&lang=js&"
export * from "./changeLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b216c62",
  null
  
)

export default component.exports